(function () {
  function FeaturedCollections(section) {
    this.section = section;

    this.tabs = this.section.querySelectorAll(".featured-collections__tab");
    this.contents = this.section.querySelectorAll(
      ".featured-collections__content",
    );
    this.carousels = this.section.querySelectorAll(".product-carousel");
    this.flickities = [];

    this.initTabs();
    this.initCarousels();
  }

  FeaturedCollections.prototype.initTabs = function () {
    var _this = this;

    this.tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        _this.tabs.forEach(function (t) {
          t.classList.remove("is-active");
        });

        tab.classList.add("is-active");

        var id = tab.getAttribute("data-tab");

        _this.contents.forEach(function (c) {
          c.classList.add("hidden");
        });

        var active = _this.section.querySelector("#collection-" + id);
        if (active) active.classList.remove("hidden");
      });
    });
  };

  FeaturedCollections.prototype.initCarousels = function () {
    var _this = this;

    this.carousels.forEach(function (carousel) {
      var flkty = new window.Flickity(carousel, {
        cellAlign: "left",
        contain: true,
        pageDots: false,
        groupCells: true,
        prevNextButtons: true,
        draggable: true,
      });
      _this.flickities.push(flkty);
    });
  };

  FeaturedCollections.prototype.onUnload = function () {
    this.flickities.forEach(function (flkty) {
      flkty.destroy();
    });
  };

  window.FeaturedCollections = FeaturedCollections;
})();

window.FeaturedCollectionsRegistry = window.FeaturedCollectionsRegistry || {};

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll('[id^="featured-collections-"]')
    .forEach((sectionEl) => {
      const id = sectionEl
        .getAttribute("id")
        .replace("featured-collections-", "");
      window.FeaturedCollectionsRegistry[id] = new window.FeaturedCollections(
        sectionEl,
      );
    });
});
